import styled from 'styled-components';

export const StyledVoucherBar = styled.div`
  background: #8ac34b;
  border-radius: ${props => props.theme.borderRadius};
  color: #fff;
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: 600;
  text-align: center;
  padding: 15px 0;
  margin: 15px 0;
`
